import { render, staticRenderFns } from "./MyRecipe_Wizard.vue?vue&type=template&id=cf1750c4&scoped=true&"
import script from "./MyRecipe_Wizard.vue?vue&type=script&lang=js&"
export * from "./MyRecipe_Wizard.vue?vue&type=script&lang=js&"
import style0 from "./MyRecipe_Wizard.vue?vue&type=style&index=0&id=cf1750c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1750c4",
  null
  
)

export default component.exports